import { getData, postData, putData, deleteData } from "../apiClient";

const ItemName = "AboutUs";
const API_URL = "about-us";

// get all with pagination
export const GetAll = async ({ page = 1, limit = 10, search = "" }, signal = null) => {
  try {
    const queryParams = new URLSearchParams({
      page: String(page),
      limit: String(limit),
      search: search,
    });
    const result = await getData(`/${API_URL}/?${queryParams}`, {}, {}, signal);
    return { success: true, ...result };
  } catch (error) {
    console.error(`Get ${ItemName} with pagination API error:`, error);
    return { success: false, ...error };
  }
};

// get single item by id
export const GetById = async (id) => {
  try {
    const result = await getData(`/${API_URL}/${id}`);
    return { data: { success: true, ...result } };
  } catch (error) {
    console.error(`Get ${ItemName} by id API error:`, error);
    return { data: { success: false, error: error.message } };
  }
};

// create item (multipart/form-data for images)
export const Create = async ({ data }) => {
  try {
    const result = await postData(`/${API_URL}/`, data, { "Content-Type": "multipart/form-data" });
    return { data: { success: true, data: result } };
  } catch (error) {
    console.error(`Create ${ItemName} API error:`, error);
    return { data: { success: false, error: error.message } };
  }
};

// update item (multipart/form-data)
export const Update = async ({ id, data }) => {
  try {
    const result = await putData(`/${API_URL}/${id}`, data, { "Content-Type": "multipart/form-data" });
    return { data: { success: true, data: result } };
  } catch (error) {
    console.error(`Update ${ItemName} API error:`, error);
    return { data: { success: false, error: error.message } };
  }
};


